module.exports = __webpack_public_path__ + "img/projects-details-2.da711620.jpg";